var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.782 17.6971C12.4266 17.3316 12.4069 16.764 12.7174 16.376L12.8019 16.283L16.236 12.945L5.99898 12.9444C5.44669 12.9444 4.99898 12.4967 4.99898 11.9444C4.99898 11.4316 5.38501 11.0089 5.88236 10.9512L5.99898 10.9444L16.236 10.945L12.8019 7.60587C12.4364 7.2505 12.4007 6.68371 12.7001 6.28717L12.782 6.1918C13.1373 5.82627 13.7041 5.79056 14.1007 6.09003L14.196 6.17188L19.396 11.2274C19.4369 11.2678 19.4726 11.3087 19.5042 11.3515L19.5612 11.4374L19.6174 11.5482L19.6451 11.6199L19.6724 11.7146L19.6862 11.785L19.6973 11.8858L19.6973 12.0031L19.683 12.1229L19.6643 12.2062L19.628 12.3152L19.6051 12.3683L19.5581 12.4565L19.4821 12.5665L19.433 12.6236L19.3961 12.6614L14.1961 17.717C13.8001 18.102 13.167 18.0931 12.782 17.6971Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.720df8f02df74d459fbe27af9fad12af.svg";
export { ForwardRef as ReactComponent };